// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"gN-z","upvoteIcon":"hN-z","downvoteIcon":"iN-z","feedbackIcon":"jN-z"};